/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApplicationCredentialsDto,
  BankAccountResponse,
  ConsentDto,
  DownloadUserProfilesCsvRequest,
  GetAllUserProfilesCsvParams,
  GetAllUserProfilesParams,
  GetConsentsParams,
  GetOrganisationUserProfilesParams,
  OrganisationDto,
  OrganisationResponse,
  PageUserProfileResponse,
  ProductSwitchApplicationDto,
  StripeCustomerDataResponse,
  SwitchOrganisationRequest,
  SwitchOrganisationResponseDto,
  UpdateOrganisationRequest,
  UpdateOrganisationUserCostCenterBulkRequest,
  UpdateOrganisationUserCostCenterRequest,
  UpdateOrganisationUserRoleRequest,
  UserOrganisationDto,
  UserProfileResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiOrganisationController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name Get
   * @request GET:/api/v1/organisation
   */
  get = (params: RequestParams = {}) =>
    this.http.request<OrganisationResponse, any>({
      path: `/v1/organisation`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPath = '/v1/organisation'
  static getMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name Update
   * @request PUT:/api/v1/organisation
   */
  update = (data: UpdateOrganisationRequest, params: RequestParams = {}) =>
    this.http.request<OrganisationResponse, any>({
      path: `/v1/organisation`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updatePath = '/v1/organisation'
  static updateMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name UpdateOrganisationUserRoles
   * @request PUT:/api/v1/organisation/users/{userId}/roles
   */
  updateOrganisationUserRoles = (
    userId: string,
    data: UpdateOrganisationUserRoleRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/organisation/users/${userId}/roles`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateOrganisationUserRolesPath = '/v1/organisation/users/${userId}/roles'
  static updateOrganisationUserRolesMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name UpdateSso
   * @request PUT:/api/v1/organisation/sso
   */
  updateSso = (data: OrganisationDto, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/organisation/sso`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateSsoPath = '/v1/organisation/sso'
  static updateSsoMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name UpdateOrganisationUserCostCenter
   * @request POST:/api/v1/organisation/users/{userId}/cost-center
   */
  updateOrganisationUserCostCenter = (
    userId: string,
    data: UpdateOrganisationUserCostCenterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/organisation/users/${userId}/cost-center`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateOrganisationUserCostCenterPath = '/v1/organisation/users/${userId}/cost-center'
  static updateOrganisationUserCostCenterMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name UpdateOrganisationUserCostCentersBulk
   * @request POST:/api/v1/organisation/users/cost-center-bulk-update
   */
  updateOrganisationUserCostCentersBulk = (
    data: UpdateOrganisationUserCostCenterBulkRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/organisation/users/cost-center-bulk-update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateOrganisationUserCostCentersBulkPath =
    '/v1/organisation/users/cost-center-bulk-update'
  static updateOrganisationUserCostCentersBulkMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name GetAllUserProfilesCsv
   * @request GET:/api/v1/organisation/users/all/csv
   */
  getAllUserProfilesCsv = (query: GetAllUserProfilesCsvParams, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/organisation/users/all/csv`,
      method: 'GET',
      query: query,
      ...params,
    })

  static getAllUserProfilesCsvPath = '/v1/organisation/users/all/csv'
  static getAllUserProfilesCsvMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name DownloadUserProfilesCsv
   * @request POST:/api/v1/organisation/users/all/csv
   */
  downloadUserProfilesCsv = (data: DownloadUserProfilesCsvRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/organisation/users/all/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static downloadUserProfilesCsvPath = '/v1/organisation/users/all/csv'
  static downloadUserProfilesCsvMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name SwitchOrganisation
   * @request POST:/api/v1/organisation/switch-organisation
   */
  switchOrganisation = (data: SwitchOrganisationRequest, params: RequestParams = {}) =>
    this.http.request<SwitchOrganisationResponseDto, any>({
      path: `/v1/organisation/switch-organisation`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static switchOrganisationPath = '/v1/organisation/switch-organisation'
  static switchOrganisationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name ApplyToCredit
   * @request POST:/api/v1/organisation/apply-to-credit
   */
  applyToCredit = (data: ProductSwitchApplicationDto, params: RequestParams = {}) =>
    this.http.request<ApplicationCredentialsDto, any>({
      path: `/v1/organisation/apply-to-credit`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static applyToCreditPath = '/v1/organisation/apply-to-credit'
  static applyToCreditMethod = 'POST'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name SetHasDismissedSubscriptionActivation
   * @request PATCH:/api/v1/organisation/dismiss-subscription-activation
   */
  setHasDismissedSubscriptionActivation = (params: RequestParams = {}) =>
    this.http.request<OrganisationResponse, any>({
      path: `/v1/organisation/dismiss-subscription-activation`,
      method: 'PATCH',
      format: 'json',
      ...params,
    })

  static setHasDismissedSubscriptionActivationPath =
    '/v1/organisation/dismiss-subscription-activation'
  static setHasDismissedSubscriptionActivationMethod = 'PATCH'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name GetOrganisationUsers
   * @request GET:/api/v1/organisation/users
   */
  getOrganisationUsers = (params: RequestParams = {}) =>
    this.http.request<UserProfileResponse[], any>({
      path: `/v1/organisation/users`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getOrganisationUsersPath = '/v1/organisation/users'
  static getOrganisationUsersMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name GetOrganisationUser
   * @request GET:/api/v1/organisation/users/{userId}
   */
  getOrganisationUser = (userId: string, params: RequestParams = {}) =>
    this.http.request<UserProfileResponse, any>({
      path: `/v1/organisation/users/${userId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getOrganisationUserPath = '/v1/organisation/users/${userId}'
  static getOrganisationUserMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name RemoveUserFromOrganisation
   * @request DELETE:/api/v1/organisation/users/{userId}
   */
  removeUserFromOrganisation = (userId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/organisation/users/${userId}`,
      method: 'DELETE',
      ...params,
    })

  static removeUserFromOrganisationPath = '/v1/organisation/users/${userId}'
  static removeUserFromOrganisationMethod = 'DELETE'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name GetOrganisationUserProfiles
   * @request GET:/api/v1/organisation/users/paged
   */
  getOrganisationUserProfiles = (
    query: GetOrganisationUserProfilesParams,
    params: RequestParams = {},
  ) =>
    this.http.request<PageUserProfileResponse, any>({
      path: `/v1/organisation/users/paged`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getOrganisationUserProfilesPath = '/v1/organisation/users/paged'
  static getOrganisationUserProfilesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name GetAllUserProfiles
   * @request GET:/api/v1/organisation/users/all/paged
   */
  getAllUserProfiles = (query: GetAllUserProfilesParams, params: RequestParams = {}) =>
    this.http.request<PageUserProfileResponse, any>({
      path: `/v1/organisation/users/all/paged`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getAllUserProfilesPath = '/v1/organisation/users/all/paged'
  static getAllUserProfilesMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name GetTeamLeadUsers
   * @request GET:/api/v1/organisation/team-lead/users
   */
  getTeamLeadUsers = (params: RequestParams = {}) =>
    this.http.request<UserProfileResponse[], any>({
      path: `/v1/organisation/team-lead/users`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getTeamLeadUsersPath = '/v1/organisation/team-lead/users'
  static getTeamLeadUsersMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name GetStripeCustomerDetails
   * @request GET:/api/v1/organisation/stripe/customer
   */
  getStripeCustomerDetails = (params: RequestParams = {}) =>
    this.http.request<StripeCustomerDataResponse, any>({
      path: `/v1/organisation/stripe/customer`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getStripeCustomerDetailsPath = '/v1/organisation/stripe/customer'
  static getStripeCustomerDetailsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name GetOrganisationsOfUser
   * @request GET:/api/v1/organisation/organisations-of-user
   */
  getOrganisationsOfUser = (params: RequestParams = {}) =>
    this.http.request<UserOrganisationDto[], any>({
      path: `/v1/organisation/organisations-of-user`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getOrganisationsOfUserPath = '/v1/organisation/organisations-of-user'
  static getOrganisationsOfUserMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name GetConsents
   * @request GET:/api/v1/organisation/consents
   * @deprecated
   */
  getConsents = (query: GetConsentsParams, params: RequestParams = {}) =>
    this.http.request<ConsentDto[], any>({
      path: `/v1/organisation/consents`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getConsentsPath = '/v1/organisation/consents'
  static getConsentsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name GetBankAccounts
   * @request GET:/api/v1/organisation/accounts
   */
  getBankAccounts = (params: RequestParams = {}) =>
    this.http.request<BankAccountResponse[], any>({
      path: `/v1/organisation/accounts`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getBankAccountsPath = '/v1/organisation/accounts'
  static getBankAccountsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-organisation-controller
   * @name RemoveAdminRoleFromUser
   * @request DELETE:/api/v1/organisation/users/{userId}/admin
   */
  removeAdminRoleFromUser = (userId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/organisation/users/${userId}/admin`,
      method: 'DELETE',
      ...params,
    })

  static removeAdminRoleFromUserPath = '/v1/organisation/users/${userId}/admin'
  static removeAdminRoleFromUserMethod = 'DELETE'
}
